import { QuickstartTheme } from '../types/theme';

/** Still art behind the thank-you / device-fallback stages. */
export const resolveCampaignStageImage = (theme?: QuickstartTheme): string | undefined => {
  if (!theme) return undefined;
  const poster = theme.trailerBackgroundVideo?.posterImage || theme.loadingBackgroundVideo?.posterImage;
  return poster || theme.pageBackgroundImage || theme.ogImageUrl;
};
